import {
  Button,
  Modal,
  ModalClose,
  ModalDialog,
  Stack,
  Typography,
} from '@mui/joy';
import React from 'react';

type ConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  title,
  description,
  onConfirm,
  onCancel,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onCancel();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <Typography component="h2" level="h4" mb={1}>
          {title}
        </Typography>
        <Typography mb={2}>{description}</Typography>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="plain" onClick={handleCancel}>
            Annuleren
          </Button>
          <Button variant="solid" color="primary" onClick={handleConfirm}>
            Bevestigen
          </Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};
